(() => {
  const root = document.getElementById('swell-scratch-overlay');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const storageKey = 'swellScratchDiscountState';
  const submittedKey = 'swellScratchDiscountSubmitted';
  const companyId = root.dataset.klaviyoCompany;
  const listId = root.dataset.klaviyoList;
  const source = root.dataset.source || 'Swell scratch discount overlay';
  const delayMs = Number(root.dataset.delayMs || 8000);
  const cooldownDays = Number(root.dataset.cooldownDays || 14);

  const canvas = root.querySelector('[data-scratch-canvas]');
  const card = root.querySelector('[data-scratch-card]');
  const closeButtons = [root.querySelector('.swell-scratch__close'), root.querySelector('[data-success-close]')].filter(Boolean);
  const skipScratch = root.querySelector('[data-skip-scratch]');
  const form = root.querySelector('form[data-stage="email"]');
  const scratchStage = root.querySelector('[data-stage="scratch"]');
  const scratchHeadline = scratchStage?.querySelector('.swell-scratch__headline');
  const scratchSub = scratchStage?.querySelector('.swell-scratch__sub');
  const input = form?.querySelector('input[type="email"]');
  const error = root.querySelector('[data-error]');
  const submitButton = form?.querySelector('button[type="submit"]');

  let drawing = false;
  let revealed = false;
  let started = false;

  function now() { return Date.now(); }

  function readState() {
    try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); }
    catch (_) { return {}; }
  }

  function writeState(state) {
    try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) {}
  }

  function shouldShow() {
    try {
      if (localStorage.getItem(submittedKey) === 'true') return false;
    } catch (_) {}
    const state = readState();
    if (!state.closedAt) return true;
    return now() - state.closedAt > cooldownDays * 24 * 60 * 60 * 1000;
  }

  function show() {
    if (!shouldShow()) return;
    root.hidden = false;
    document.body.classList.add('swell-scratch-open');
    setupCanvas();
  }

  function close(cooldown = true) {
    root.hidden = true;
    document.body.classList.remove('swell-scratch-open');
    if (cooldown) writeState({ closedAt: now() });
  }

  function showStage(name) {
    root.querySelectorAll('[data-stage]').forEach(stage => {
      stage.hidden = stage.dataset.stage !== name;
    });
    if (name === 'email') setTimeout(() => input?.focus(), 100);
  }

  function setupCanvas() {
    if (!canvas || !card) return;
    const rect = card.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const dpr = Math.max(1, window.devicePixelRatio || 1);
    canvas.width = Math.round(rect.width * dpr);
    canvas.height = Math.round(rect.height * dpr);
    canvas.style.width = rect.width + 'px';
    canvas.style.height = rect.height + 'px';

    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const gradient = ctx.createLinearGradient(0, 0, rect.width, rect.height);
    gradient.addColorStop(0, '#9b741d');
    gradient.addColorStop(0.42, '#e6c663');
    gradient.addColorStop(1, '#a77c22');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, rect.width, rect.height);

    ctx.globalAlpha = 0.18;
    ctx.fillStyle = '#fff';
    for (let i = 0; i < 18; i += 1) {
      const x = (i * 73) % rect.width;
      const y = (i * 47) % rect.height;
      ctx.beginPath();
      ctx.arc(x, y, ((i * 11) % 55) + 18, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.globalAlpha = 1;
    ctx.fillStyle = 'rgba(255,255,255,.82)';
    ctx.font = '900 28px Helvetica, Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('SCRATCH HERE', rect.width / 2, rect.height / 2);

    canvas.style.opacity = '1';
    canvas.style.transition = '';
  }

  function pointerPosition(event) {
    const rect = canvas.getBoundingClientRect();
    const point = event.touches ? event.touches[0] : event;
    return { x: point.clientX - rect.left, y: point.clientY - rect.top };
  }

  function scratch(event) {
    if (!drawing || revealed || !canvas) return;
    event.preventDefault();
    const ctx = canvas.getContext('2d');
    const p = pointerPosition(event);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.arc(p.x, p.y, 28, 0, Math.PI * 2);
    ctx.fill();
    checkReveal();
  }

  function checkReveal() {
    if (revealed || !canvas) return;
    const ctx = canvas.getContext('2d');
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let clear = 0;
    const sampleStep = 64;
    for (let i = 3; i < pixels.length; i += sampleStep) {
      if (pixels[i] === 0) clear += 1;
    }
    if (clear / (pixels.length / sampleStep) > 0.34) reveal();
  }

  function reveal() {
    if (revealed) return;
    revealed = true;
    root.classList.add('swell-scratch--revealed');
    if (scratchHeadline) scratchHeadline.textContent = 'Congratulations';
    if (scratchSub) scratchSub.textContent = 'You’ve unlocked A$250 off your Swell Sport order.';
    if (skipScratch) skipScratch.hidden = true;
    if (canvas) {
      canvas.style.transition = 'opacity .35s ease';
      canvas.style.opacity = '0';
    }
    setTimeout(() => {
      root.classList.remove('swell-scratch--revealed');
      showStage('email');
    }, 3500);
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  async function subscribe(email) {
    if (!listId) throw new Error('Missing Klaviyo list config.');

    const body = new URLSearchParams({
      g: listId,
      email,
      $fields: '$source,lead_magnet,offer,product_interest,form_concept',
      $source: source,
      lead_magnet: 'mystery_swell_sport_discount',
      offer: 'A$250_off_swell_sport',
      product_interest: 'swell_sport',
      form_concept: 'scratch_card_overlay'
    });

    const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: body.toString(),
      keepalive: false
    });

    let result = null;
    try { result = await response.json(); } catch (_) {}

    if (!response.ok || result?.success === false) {
      throw new Error(result?.errors?.join(', ') || `Klaviyo subscribe failed (${response.status})`);
    }
  }

  function bind() {
    if (started) return;
    started = true;
    closeButtons.forEach(btn => btn.addEventListener('click', () => close(true)));
    skipScratch?.addEventListener('click', reveal);

    canvas?.addEventListener('mousedown', event => { drawing = true; scratch(event); });
    window.addEventListener('mouseup', () => { drawing = false; });
    canvas?.addEventListener('mousemove', scratch);
    canvas?.addEventListener('touchstart', event => { drawing = true; scratch(event); }, { passive: false });
    canvas?.addEventListener('touchmove', scratch, { passive: false });
    canvas?.addEventListener('touchend', () => { drawing = false; });

    window.addEventListener('resize', () => {
      if (!root.hidden && !revealed) setupCanvas();
    });

    form?.addEventListener('submit', async event => {
      event.preventDefault();
      const email = input?.value?.trim();
      if (!validEmail(email)) {
        if (error) { error.hidden = false; error.textContent = 'Enter a valid email address.'; }
        return;
      }
      if (error) error.hidden = true;
      if (submitButton) { submitButton.disabled = true; submitButton.textContent = 'Claiming…'; }
      try {
        await subscribe(email);
        try { localStorage.setItem(submittedKey, 'true'); } catch (_) {}
        showStage('success');
      } catch (err) {
        if (error) { error.hidden = false; error.textContent = 'Could not submit. Please try again.'; }
        console.warn('Swell scratch discount submit failed:', err);
      } finally {
        if (submitButton) { submitButton.disabled = false; submitButton.textContent = 'Claim offer'; }
      }
    });
  }

  bind();
  window.setTimeout(show, delayMs);
})();
